import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Path card — clickable card used on the homepage for the three owner paths.
 *
 * Props:
 *   icon       — JSX element rendered inside the eyebrow row (use one of the
 *                inline SVG icons defined below or pass your own)
 *   step       — short label like "Path 01"
 *   title      — Fraunces headline
 *   description — body copy
 *   connectsLabel — small grey label e.g. "Connects you with"
 *   connectsTo    — line label e.g. "Lenders →"
 *   to            — react-router target
 */
export default function PathCard({
  icon,
  step,
  title,
  description,
  connectsLabel = 'Connects you with',
  connectsTo,
  to,
}) {
  return (
    <Link to={to} className="oc-path-card">
      <div className="oc-path-card__head">
        <span className="oc-path-card__icon" aria-hidden="true">{icon}</span>
        <span className="oc-eyebrow">{step}</span>
      </div>
      <h3 className="oc-h3" style={{ marginBottom: 10 }}>{title}</h3>
      <p className="oc-body-sm" style={{ marginBottom: 20 }}>{description}</p>
      <hr className="oc-rule" style={{ marginBottom: 16 }} />
      <div className="oc-row-sb" style={{ marginTop: 'auto' }}>
        <span className="oc-body-sm oc-muted" style={{ fontSize: 12 }}>{connectsLabel}</span>
        <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--oc-ink)' }}>{connectsTo}</span>
      </div>
    </Link>
  );
}

/* ---- Icons used by the three owner paths --------------------- */

export const IconFinancing = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 6 h18 M3 12 h18 M3 18 h18" />
    <circle cx="8"  cy="6"  r="1.5" fill="currentColor" />
    <circle cx="16" cy="12" r="1.5" fill="currentColor" />
    <circle cx="10" cy="18" r="1.5" fill="currentColor" />
  </svg>
);

export const IconInvestors = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M4 18 L4 8 M10 18 L10 4 M16 18 L16 11 M22 18 L22 6" />
    <path d="M2 21 h22" />
  </svg>
);

export const IconSell = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M4 12 h12 M12 6 l6 6 -6 6" />
  </svg>
);
